jQuery(document).ready(function($) {
	$("#toggle-reviews").on('click',function(e){
        e.preventDefault();
		$('.user-review-item:hidden').slice(0,5).show();
		if(!$('.user-review-item').is(":hidden")) {
			$(this).addClass('is-hidden');
		}
    });
});
